export function formatPhoneNumber(phoneNumber) {
    // Eliminar todos los caracteres que no sean dígitos
    phoneNumber = phoneNumber.replace(/\D/g, '');

    // Aplicar el formato (XXX) XXX-XXXX
    phoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

    return phoneNumber;
}